<template>
  <div>
    <ul class="tree-filter">
      <li :class="headerClass" class="option-all mb1">
        <a @click="$emit('itemClick', null)"
           :class="checkAllClass()">
          {{allLabel}}: <span v-if="showCount && counts">{{counts['TOTAL']}}</span>
        </a>
      </li>

      <template v-if="detailOpts!==null">
        <div>
          <button class="btn btn-neutral m1"
                  style="width: 90%"
                  @click="$emit('detailModal')">
            select applications
          </button>
        </div>
        <template v-for="(val, appId) in detailOpts">
          <div :key="appId" v-if="val" class="text-tag opt-val">
            {{modalOptText(appId, val)}}
          </div>
        </template>
      </template>

      <template v-if="groups">
        <li v-for="group in listItems" :key="group.id">
          <template v-if="group.heading">
            <div class="tree-heading">{{group.heading}}</div>
          </template>
          <template v-else>
            <a @click="groupSelectClick(group.id)" class="filter-group">
              {{groupSelectIcon(group.id)}}
            </a>
            <a @click="groupClick(group.id)" class="hover-hi">
              <span v-if="expanded[group.id]">⯆</span>
              <span v-else>⯈</span>
              <span :title="definition(group.id)">
                {{groups[group.id].label}}<span v-if="showCount && countsGroup!==null"
                                                class="item-count">
                  ({{countsGroup[group.id] || 0}})
                </span>
              </span>
            </a>
            <template v-if="expanded[group.id]">
              <div v-for="itemId in groups[group.id].items" :key="itemId" class="hover-hi">
                <a @click="$emit('itemClick', itemId)"
                   :class="checkClass(itemId)" class="tree-sub-item">
                  {{items[itemId].label}}
                  <span v-if="showCount">({{counts[itemId] || 0}})</span>
                </a>
              </div>
            </template>
          </template>
        </li>
      </template>
      <!-- simple list without tree -->
      <template v-else>
        <template v-for="itemId in listItems">
          <li v-if="show===null || itemId in show" :key="itemId"
              :class="{'li-disabled': showCount && !counts[itemId]}" class="hover-hi">
            <a @click="$emit('itemClick', itemId)"
               :class="checkClass(itemId)">
              {{items[itemId].label}}
              <span v-if="showCount && counts">({{counts[itemId] || 0}})</span>
            </a>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TreeFilter',
  components: { },
  props: {
    headerClass: null,
    allLabel: null,
    // Array of key of top-level items in structure.
    // If really tree each element corresponds to the key of `groups`.
    // If flat list, each element corresponds to key of items
    listItems: null,
    // groups: Object with {code, label, items}
    groups: null,
    // if `groups` is used, items contain 2nd-level {id, label}
    // if not `groups`, contains top-level {code, label}
    items: null,
    show: { default: null }, // if present, control which items to be displayed
    filters: Object, // {code: boolean} - contains items only (group is implicit)
    counts: {},
    countsGroup: { default: null }, // if null, don't show count for group
    showCount: { default: true },
    defs: { default: null }, // show defintion on hover
    // selected sub items from tree that are displayed on pop-up modal
    detailOpts: { default: null },
  },

  data() {
    return {
      expanded: {},
    };
  },

  created() {
  },

  computed: {
  },

  methods: {
    groupClick(code) {
      if (this.expanded[code]) {
        this.$set(this.expanded, code, false);
      } else {
        this.$set(this.expanded, code, true);
      }
    },
    groupSelectClick(code) {
      const current = this.groupCheck(code);
      const val = current !== 'all';
      this.$emit('groupClick', code, val);
    },
    groupSelectIcon(code) {
      const current = this.groupCheck(code);
      if (current === 'none') {
        return '▢';
      }
      if (current === 'all') {
        return '✓'; // ▣
      }
      return '◪';
    },

    checkClass(code) {
      return this.filters[code] ? 'filter-selected' : 'filter-unselected';
    },
    checkAllClass() {
      if (!Object.values(this.filters).some((x) => x)) {
        return 'filter-selected';
      }
      return 'filter-unselected';
    },
    groupCheck(code) {
      let off = 0;
      let on = 0;
      for (const itemId of this.groups[code].items) {
        if (this.filters[itemId]) {
          on++;
        } else {
          off++;
        }
      }
      if (on) {
        if (off) {
          return 'some';
        }
        return 'all';
      }
      return 'none';
    },

    definition(code) {
      if (this.defs && code in this.defs) {
        return this.defs[code];
      }
      return null;
    },

    modalOptText(appId, val) {
      return val;
    },

  },
};
</script>

<style>
  .tree-heading {
    margin-top: 4px;
    font-size: 16px;
    text-transform: uppercase;
    color: #494848;
  }
  .tree-filter {
    font-size:12px;
    line-height: 18px;
    /* border-left: 2px solid #94C232; */
  }
  .tree-filter li {
    padding: 2px 8px;

    cursor: pointer;
    font-family: Tahoma;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.04em;
    color: #000000;
  }
  .hover-hi:hover {
    background-color: #D2D2D2;
  }
  .tree-filter li.option-all {
    opacity: 0.8;
    padding: 14px 8px;
    border-radius: 4px;
  }

  .tree-sub-item {
    padding-left: 32px;
    text-indent:-16px;
    display: inline-block;
    line-height: 20px;
  }

  .item-count {
    white-space: nowrap;
  }
  .item-count:before {
    content: " ";
  }

  .filter-selected {
    font-weight: bold;
  }
  .filter-unselected::before {
    content: "☐";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }
  .li-disabled .filter-unselected::before {
    content: "■";
    color: #E0E1E1;
    margin-left: -1px;
  }
  /* ☑ ☒ */
  .filter-selected::before {
    content: "✓";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }
  /* □ ◪ ▣ */
  .filter-group {
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }

  .tree-filter li.li-disabled {
    color: #767676;
  }

  .opt-val {
    display: block;
    margin-left: 10px;
    margin-right: 20px;
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 15px;
    text-align: left;
  }
</style>
